import * as React from "react";
import { TextField } from "@fluentui/react/lib/TextField";
import { IBaseInputProps } from "../../../../../interfaces/advancedSearch/IBaseInputProps";
import { ITextStyles } from "@fluentui/react";

export const TextFieldInput: React.FunctionComponent<IBaseInputProps> = props => {
  const handleOnChange = (event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue: string): void => {
    props.handleValueChange(props.searchInputData?.index, newValue);
  };

  const textStyles: Partial<ITextStyles> = { root: { width: "100%" } };
  return (
    <TextField
      label={props.displayName}
      type="text"
      value={props.searchInputData?.value ?? ""}
      styles={textStyles}
      onChange={handleOnChange}
      className="xb-sp-input"
    />
  );
};

export default TextFieldInput;
